<template>
    <BaseModal
        v-if="show"
        :title="title"
        max-width="2xl"
        @close="$emit('close')"
    >
        <div class="sm:flex sm:items-start">
            <div
                class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10"
            >
                <AlertTriangle class="h-6 w-6 text-red-600" />
            </div>
            <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                <p class="text-sm text-gray-500">
                    {{ message }}
                </p>
            </div>
        </div>
        <template #footer="{ close }">
            <button
                type="button"
                class="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 rounded-md hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
                @click="close"
            >
                Cancel
            </button>
            <button
                type="button"
                class="px-4 py-2 text-sm font-medium text-white bg-red-600 rounded-md hover:bg-red-700 transition-colors"
                @click="$emit('confirm')"
            >
                Delete
            </button>
        </template>
    </BaseModal>
</template>

<script setup lang="ts">
import { AlertTriangle } from "@lucide/vue";
import BaseModal from "@/components/BaseModal.vue";

defineProps<{
    show: boolean;
    title: string;
    message: string;
}>();

defineEmits<{
    close: [];
    confirm: [];
}>();
</script>
